export const ProjectModel = [
    {
        name: "KKPBIZ",
        role: "iOS Developer",
        skill: [
            "Swift",
            "Kotlin Multiplatform",
            "Storyboard"
        ],
        problem: "Mobile banking for Kiatnakin Phatra Bank's corporate clients.",
        contributions: [
            "Built over half of the iOS UI and business logic in Swift on a Kotlin Multiplatform shared layer.",
            "Integrated the Promon Shield SDK for app hardening."
        ],
        status: "Live on the App Store",
        link: "https://apps.apple.com/us/app/kkp-biz/id1665856562",
        linkLabel: "View on the App Store"
    }, {
        name: "Rimping",
        role: "Lead iOS Developer",
        skill: [
            "Swift",
            "SwiftUI",
            "Kotlin Multiplatform"
        ],
        problem: "Supermarket app for Rimping's customers.",
        contributions: [
            "Owned the iOS side end to end, from architecture through to release.",
            "Built in SwiftUI on a Kotlin Multiplatform shared layer."
        ],
        status: "Live on the App Store",
        link: "https://apps.apple.com/th/app/rimping/id6738688550",
        linkLabel: "View on the App Store"
    }, {
        name: "WISET",
        role: "Flutter Developer",
        skill: [
            "Flutter",
            "Dart"
        ],
        problem: "SET's consolidated investment-portfolio and market app.",
        contributions: [
            "Worked on app stability and defect resolution across the Flutter codebase."
        ],
        status: "Live on the App Store",
        link: "https://apps.apple.com/th/app/wiset/id6756988677",
        linkLabel: "View on the App Store"
    }, {
        name: "Jernie",
        role: "Solo Developer",
        skill: [
            "SwiftUI",
            "MVVM",
            "SwiftData"
        ],
        problem: "A travelling social platform app, built solo.",
        contributions: [
            "Built with SwiftUI using MVVM, NavigationStack routing, and SwiftData persistence.",
            "Designed, built, and shipped to testers without a team."
        ],
        status: "In beta on TestFlight",
        link: "https://beta.jernie.app",
        linkLabel: "Join the TestFlight beta"
    }, {
        name: "Algorithmic Trading Bot",
        role: "Solo Developer",
        skill: [
            "Python",
            "PM2"
        ],
        problem: "Automated paper-trading bot for US equities.",
        contributions: [
            "Runs autonomously through market sessions with scheduled startup and shutdown.",
            "Python service kept alive under PM2."
        ],
        status: "Personal project — paper trading only",
        link: null,
        linkLabel: null
    }
]
